import { ID, Response } from 'app/components/Table/core/types';

import { exportCSV } from 'app/modules/reporting/core/helpers';

import { trimObject } from 'app/helpers';
import { getResponseError } from 'app/helpers/errors';

import { API_URL } from 'app/constants/environments';

import { Ward, WardRequest, WardsQueryResponse } from './type';
import axios, { AxiosResponse } from 'axios';
import { useOrganizationStore } from 'theme/layout/components/aside/store';

const WARD_URL = `${API_URL}/api`;

const getWards = (query: string): Promise<WardsQueryResponse> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  const params = new URLSearchParams(query);
  if (organizationId && !query.includes('orgId')) {
    params.append('orgId', organizationId.toString());
  }

  return axios.get(`${WARD_URL}/orgs/${organizationId}/wards?${params.toString()}`).then(
    (
      d: AxiosResponse<{
        data: {
          items: Array<Ward>;
          total: number;
        };
      }>,
    ) => {
      return {
        data: d.data.data,
      };
    },
  );
};
const getWard = (idWard: ID): Promise<Ward | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .get(`${WARD_URL}/orgs/${organizationId}/wards/${idWard}`)
    .then((response: AxiosResponse<Response<Ward>>) => response.data)
    .then((response: Response<Ward>) => response.data);
};

const createWard = (request: WardRequest): Promise<Ward | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .post(`${WARD_URL}/orgs/${organizationId}/wards`, trimObject(request))
    .then((response: AxiosResponse<Response<Ward>>) => response.data)
    .then((response: Response<Ward>) => response.data);
};

const updateWard = (idWard: ID, request: WardRequest): Promise<Ward | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${WARD_URL}/orgs/${organizationId}/wards/${idWard}`, trimObject(request))
    .then((response: AxiosResponse<Response<Ward>>) => response.data)
    .then((response: Response<Ward>) => response.data);
};

const deleteWard = async (idWard: ID): Promise<void> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  try {
    await axios.delete(`${WARD_URL}/orgs/${organizationId}/wards/${idWard}`);
  } catch (error) {
    console.log(`Error deleting ward ID ${idWard}`);
    throw error;
  }
};

const updateWardLayout = async (
  idWard: ID,
  request: { chore: string },
): Promise<Ward | undefined> => {
  const organizationId = useOrganizationStore.getState().state.organization?.id;

  return axios
    .patch(`${WARD_URL}/orgs/${organizationId}/wards/${idWard}/chore`, trimObject(request))
    .then((response: AxiosResponse<Response<Ward>>) => response.data)
    .then((response: Response<Ward>) => response.data);
};

const downloadTemperature = async (params: { wardId: ID }): Promise<void> => {
  try {
    const response: AxiosResponse<{ data: string; success: boolean; message: string }> =
      await axios.get(`${API_URL}/api/report/temperature`, { params });

    if (!response.data.success)
      throw new Error(response.data.message || 'Error downloading temperature');

    exportCSV(response.data.data, 'Temperature');
  } catch (error) {
    console.error('Error downloading temperature:', error);
    getResponseError(error);
    throw error;
  }
};

export {
  getWards,
  getWard,
  createWard,
  updateWard,
  deleteWard,
  updateWardLayout,
  downloadTemperature,
};
